import type { CSSProperties } from 'react';
import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, smallElevation } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { spacing } = theme;

export const FADE_WIDTH_PX = 32;
const ARROW_SIZE_PX = 40;

export const nav = css`
  display: flex;
  align-items: center;
  column-gap: ${spacing.sm}px;
  min-width: 0;
`;

export interface ScrollContainerCSS extends CSSProperties {
  '--fadeLeftWidth'?: string;
  '--fadeRightWidth'?: string;
}

/* The edges fade by masking the content rather than painting the page colour over it,
   so the fade still blends in over a translucent or image background. */
export const scrollContainer = css`
  flex: 1;
  min-width: 0;
  overflow-x: auto;
  scroll-behavior: smooth;
  /* Hide the native scrollbar — scrolling is via swipe (touch) or the arrows. */
  scrollbar-width: none;
  -ms-overflow-style: none;

  mask-image: linear-gradient(
    to right,
    transparent,
    #000 var(--fadeLeftWidth, 0px),
    #000 calc(100% - var(--fadeRightWidth, 0px)),
    transparent
  );

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const arrow = css`
  display: none;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: ${ARROW_SIZE_PX}px;
      height: ${ARROW_SIZE_PX}px;
      padding: 0;
      border-radius: 50%;
      border: 1px solid transparent;
      background: var(${themeVariables.colors.surface.default});
      color: var(${themeVariables.colors.content.default});
      cursor: pointer;
      ${smallElevation};

      &:hover {
        border-color: var(${themeVariables.colors.stroke.interactive});
      }
    `,
  )}
`;
